// The invite's contact email reaches the browser end-masked by the server (its first two
// characters plus a trailing "*" -- MorteeCommonDTOMapper.maskEndOfString), so the step can only
// tell the supplier how the invited address starts. The server still asserts the exact address on
// submit (EMAIL_MISMATCH); the hint and the prefix check exist to catch the mismatch before the
// one-time-code round trip, not to replace that assertion.
const MASKING_SUFFIX = /\*+$/;

export function getInvitedEmailHint(maskedEmail: string | null | undefined): string | undefined {
  const hint = maskedEmail?.trim().replace(MASKING_SUFFIX, '');

  return hint ? hint : undefined;
}

export function matchesInvitedEmailHint(email: string, hint: string): boolean {
  return email.trim().toLowerCase().startsWith(hint.toLowerCase());
}
